module.exports = __webpack_public_path__ + "03_veryshort_black.46b443df.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_veryshort_black.png
// module id = eePi
// module chunks = 0